import { Record } from 'immutable';
import { schema } from 'normalizr';

export const CicStatusHistory = new Record({
  id: undefined,
  cic: undefined,
  version: undefined,
  iccid: undefined,
  receive_time: undefined,
  cpu_temperature: undefined,
  input_voltage: undefined,
  modem_temperature: undefined,
  rssi: undefined,
  video_detected: undefined,
  alarm_enabled: undefined,
  alarm_delay: undefined,
  alarm_interval: undefined,
  alarm_photo_count: undefined,
  check_in_time: undefined,
  data_session_timeout: undefined,
  minimum_time_between_alarms: undefined,
  unit_time: undefined,
});

export const cicStatusHistorySchema = new schema.Entity('cicStatusHistories');

// for reading in nested models, object with { field: schema }
// cicStatusHistorySchema.define({  });
